import { buildPath } from 'common/extensibility/AddinContainer';

export const CVE_DRAWER_ID = 'cve-drawer-id';
export const VULNERABILITY_DRAWER_ID = 'vulnerability_drawer_id';
export const PACKAGE_DRAWER_ID = 'package-drawer-id';
export const VULNERABILITY_EXCLUSION_DRAWER = 'vulnerability-exclusion-drawer';
export const PATH_CVE_VIEWER_PANELS = buildPath('cve-explorer', 'cve-overview');
export const PATH_CVE_FINDING_ASSET_PANEL_FIELDS = buildPath(PATH_CVE_VIEWER_PANELS, 'fields');
